import axios from "axios";

import {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';

import Navbar from './Navbar'
import Topbar from './Topbar'
import {APIURL} from './config'

function NovaIdeia() {

    const navigate = useNavigate()

    const [titulo, setTitulo] = useState()
    const [descricao, setDescricao] = useState()

    useEffect(() => {
        if (!sessionStorage.getItem("tokeninovacao")) {
            navigate('/login')
        }
       
    }, [])

    const  doSend = async (e) => {
        e.preventDefault()
        try {

            const res = await axios.post(`${APIURL}/Inovation/InsertIdea`, {TOKEN:  sessionStorage.getItem("tokeninovacao") , Resume : titulo, Description: descricao, ProcessWorkflow: false})
            if (res.data.Return) {
                navigate('/ideias')
            } else {
                alert(res.data.Description)
            }
        }
        catch(err){
            alert(err)
        }

    }


  return (
    <div>
        <Topbar />
        <div className="container py-4 px-2 px-md-5 ">
            <div className="h4 mb-3">Nova Ideia</div>
            <div className="bg-white shadow-sm p-5">
                <div className="row ">
                    <div className="col-12">
                        <form onSubmit={(e)=> doSend(e)} role="form">
                                <div className="form-group mb-3"><label>Título</label> <input type="text"  className="form-control" onChange={(e)=> setTitulo(e.target.value)}/></div>
                                <div className="form-group mb-3"><label>Descrição</label> <textarea  rows={6}  className="form-control" onChange={(e)=> setDescricao(e.target.value)}/></div>
                                <div style={{ display: 'flex',  alignItems: 'baseline', justifyContent:'space-between', marginTop: 40}}>
                                    <div className="minhafonte"><i className="bi bi-paperclip fs-4"></i>ANEXAR</div>
                                    <div style={{ display: 'flex',  alignItems: 'baseline', justifyContent:'end'}}>
                                        <button style={{marginRight: 20}} className="btn btn-md  btn-outline-secondary" ><strong>SALVAR RASCUNHO</strong></button>
                                        <button onClick={(e)=>doSend(e)} className="btn btn-md btn-success " type="submit"><strong>ENVIAR</strong></button>
                                    </div>
                                </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
  );
}

export default NovaIdeia;